import { memo, useEffect, useMemo, useState } from "react";
import { useTable, usePagination, useFilters, useRowSelect } from "react-table";
import { useTranslation } from "react-i18next";
import "./style.css";
import { Block } from "../../../crRender";
import PageInfo from "./pageinfo";
import Pagging from "./pagging";
import { CheckboxColumn, HeaderCheckboxColumn } from "../components/CheckboxColumn";
import { ColumnsGenerator } from "@/utils/tableUtils";

export const PAGE_SIZE = 20;

const Table = ({
  columns,
  data,
  fetchData,
  setTableFiller,
  tableFiller,
  TotalRows,
  isNeedFetch = true,
  handleSelected,
  hiddenColumns,
  needCheckbox,
  assignRelatedClass,
  isPagination = true,
  isLoading,
  hideActions,
  stickyActions=false
}) => {
  const { t } = useTranslation();
  const [paginationPages, setPaginationPages] = useState([])

  const handleHide = useMemo(() => {
    let arr = []
    if (hideActions) {
      arr.push("actions")
    }
    if (hiddenColumns) {
      arr.push(hiddenColumns)
    }
    arr.push("")
    return arr
  }, [hideActions, hiddenColumns])

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    selectedFlatRows,
    state: { pageIndex, pageSize, filters, selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      pageCount: Math.ceil(TotalRows / tableFiller?.pageSize),
      initialState: {
        pageIndex: 0,
        pageSize: tableFiller?.pageSize || 20,
        hiddenColumns: handleHide,
      },
      defaultColumn: { Filter: "" },
      manualPagination: true,
      manualFilters: true,
    },
    useFilters,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) =>
        needCheckbox ?
          [
            ColumnsGenerator.CheckboxColumn(
              HeaderCheckboxColumn, CheckboxColumn
            ), ...columns]
          : columns)
    }
  );


const isActionsColumn = (id) =>
  ['actions', 'action', 'actions-column'].includes(id);


const getStickyClasses = (id, isHeader = false) => {
  if (!stickyActions || !isActionsColumn(id)) return '';

  return isHeader
    ? 'sticky-col sticky-h'
    : 'sticky';
};






  useEffect(() => {
    if (isPagination && isNeedFetch) fetchData({ pageIndex, pageSize, filters });
  }, [fetchData, pageIndex, pageSize, isPagination, filters]);

  useEffect(() => {
    let tempArr = []
    if (TotalRows / tableFiller?.pageSize >= 0) {

      for (var i = 2; i <= Math.ceil(TotalRows / tableFiller?.pageSize); i++) {
        tempArr.push(i)
      }
      setPaginationPages([...tempArr])
    }
  }, [TotalRows, tableFiller?.pageSize])

  useEffect(() => {
    if (!!selectedFlatRows?.length)
      handleSelected?.(selectedFlatRows)
    if(selectedFlatRows?.length === 0)
      handleSelected?.([])
  }, [selectedFlatRows?.length])


  // @ahmed tamer
  // this is an initial try to fix classnames passed to the cols and cells
  // if ok i will refactor it and refine the code
  return (
    <Block isRender={!isLoading} className="tablet-container">
      <PageInfo TotalRows={TotalRows} pageSize={pageSize} pageIndex={pageIndex} />

      <div className="wrapper-table">
        <table {...getTableProps()} >
          <thead  >
                {headerGroups.mapWithKey((headerGroup) => (
              <tr key={headerGroup.key} {...headerGroup.getHeaderGroupProps()}  >
                {headerGroup.headers.mapWithKey((column) =>{
                const actionsCol = isActionsColumn(column.id);
                const stickyClass = getStickyClasses(column.id, true);
                const selectCol = column.id == 'select';
                const hideCol = column.visible == false;
                  return(
                    <th key={column.key} {...column.getHeaderProps()} className={`${stickyClass} ${actionsCol || selectCol ? 'fit' : ''} ${hideCol ? 'hidden' : ''} border p-2`} >
                    {actionsCol ? t("actions") : selectCol ? column.render("Header") : t(column.render("Header"))}
                  </th>
                  )
               } )}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()} style={{ backgroundColor: "#fff" }}>
            {page.mapWithKey((row, i) => {
              prepareRow(row);

              return (
                <tr  {...row.getRowProps()} className={`${assignRelatedClass ? assignRelatedClass(row.cells) : ''} ${row.isSelected ? 'row-selected' : ''}`}>
                  {row.cells.mapWithKey((cell, index) =>{
                    const stickyClass = getStickyClasses(cell.column.id, false);
                    const actionsCol = isActionsColumn(cell.column.id);
                    const selectCol = cell.column.id === 'select';
                    const hideCol = cell.column.visible === false;
                    return(
                    <td key={cell.key} {...cell.getCellProps()} className={`${stickyClass} ${actionsCol || selectCol ? 'fit' : ''} ${hideCol ? 'hidden' : ''} p-2` }>
                      {['actions', 'action', 'actions-column'].includes(cell.column.id) ?
                        <div className="actions-column" >   {cell.render("Cell")} </div> : <div className="table-actions-container">{cell.render("Cell")}</div>
                      }
                    </td>
                    )
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Pagging
        previousPage={previousPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        canNextPage={canNextPage}
        setTableFiller={setTableFiller}
        paginationPages={paginationPages}
        pageIndex={pageIndex}
        isPagination={isPagination}
        TotalRows={TotalRows}
        canPreviousPage={canPreviousPage} />

    </Block >
  );
};

export default memo(Table);
